import React, { useState } from "react";
import { Button, Flex, Modal } from "antd";
import { WarningTwoTone } from "@ant-design/icons";
import { clientsApi, roomBookingApi } from "../../api";
import toast from "react-hot-toast";
const DeleteMeetingPopup = ({
  modalData,
  handlePopupCancel,
  setConfirmationModal,
}) => {
  const [loading,setLoading]=useState(false)
  const deleteSingleMeeting = async () => {
    const toastId = toast.loading("Loading...");
    setLoading(true)
    try {
      const resp = await roomBookingApi.deleteRoomTime({
        rtId: modalData.rtId,
        empCode: modalData.empCode,
      });
      setConfirmationModal(null);
      handlePopupCancel();
      window.dispatchEvent(new Event("meeting-booking-changed"));
      toast.success("Meeting deleted successfully");
    } catch (err) {
      setConfirmationModal(null);
      handlePopupCancel();
      toast.error("Error in deleting meeting");
    }
    setLoading(false)
    toast.dismiss(toastId);
  };

  const deleteAllMeetings = async () => {
    const toastId = toast.loading("Loading...");
    setLoading(true)

    try {
      const resp = await roomBookingApi.deleteRoomBooking({
        rbId: modalData.rbId,
        rtId: modalData.rtId,
        empCode: modalData.empCode,
      });
      // handlePopupCancel();
      setConfirmationModal(null);
      handlePopupCancel();
      window.dispatchEvent(new Event("meeting-booking-changed"));
      toast.success("All meetings deleted");
    } catch (err) {
      setConfirmationModal(null);
      handlePopupCancel();
      toast.error("Error in deleting all meetings");
    }
    setLoading(false)

    toast.dismiss(toastId);
  };


  // return (
  //   <div>
  //     <h2 id="delete-">
  //       Do you want to delete all occurences of this meeting?
  //     </h2>
  //     <Flex justify="end" gap={"0.8rem"}>
  //       <Button onClick={deleteSingleMeeting} disabled={loading}>Just this meeting</Button>
  //       <Button onClick={deleteAllMeetings} disabled={loading} type="primary">Yes</Button>
  //     </Flex>
  //   </div>
  // );
  return (
    <div>
      {modalData?.concurrenceTypeId === 3 || modalData?.concurrenceTypeId === 5 ? (
        <>
          <h2 id="delete-">
            Do you want to delete all occurrences of this meeting?
          </h2>
          <Flex justify="end" gap={"0.8rem"}>
            <Button onClick={deleteSingleMeeting} disabled={loading}>
              Just this meeting
            </Button>
            <Button onClick={deleteAllMeetings} disabled={loading} type="primary">
              Yes
            </Button>
          </Flex>
        </>
      ) : (
        <>
          <h2 id="delete-">Do you want to delete this meeting?</h2>
          <Flex justify="end">
            <Button onClick={deleteSingleMeeting} disabled={loading} type="primary">
              Yes
            </Button>
          </Flex>
        </>
      )}
    </div>
  );
  
};
export default DeleteMeetingPopup;
